import { render, staticRenderFns } from "./TheForm.vue?vue&type=template&id=f3f16862"
import script from "./TheForm.vue?vue&type=script&lang=js"
export * from "./TheForm.vue?vue&type=script&lang=js"
import style0 from "./TheForm.vue?vue&type=style&index=0&id=f3f16862&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports